var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBookmarkIconOn = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "25px",
  height: "28px",
  viewBox: "0 0 25 28",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "icons_bookmarks-copy",
  transform: "translate(-272.000000, -439.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon_bookmark_desktop_on",
  transform: "translate(272.000000, 439.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.2216749,4.922 C23.2216749,4.084 22.9339901,3.355 22.3596059,2.734 C21.7852217,2.115 21.1024631,1.805 20.3123153,1.805 L4.68768473,1.805 C3.89753695,1.805 3.2137931,2.115 2.63940887,2.734 C2.06502463,3.355 1.7773399,4.084 1.7773399,4.922 L1.7773399,25.047 L12.6078818,17.992 L23.2216749,24.992 L23.2216749,4.922 Z",
  id: "Path",
  fill: "#4585FF",
  opacity: 0.30392674
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.2216749,4.922 C23.2216749,4.084 22.9339901,3.355 22.3596059,2.734 C21.7852217,2.115 21.1024631,1.805 20.3123153,1.805 L4.68768473,1.805 C3.89753695,1.805 3.2137931,2.115 2.63940887,2.734 C2.06502463,3.355 1.7773399,4.084 1.7773399,4.922 L1.7773399,25.047 L12.6078818,17.992 L23.2216749,24.992 L23.2216749,4.922 Z M23.6522167,1.422 C24.5507389,2.37 25,3.519 25,4.867 L25,28 L12.6078818,19.906 L0,28 L0,4.867 C0,3.519 0.449261084,2.37 1.34679803,1.422 C2.24433498,0.475 3.32216749,0 4.57931034,0 L20.4197044,0 C21.6778325,0 22.7546798,0.475 23.6522167,1.422 L23.6522167,1.422 Z",
  id: "Fill-14",
  fill: "#4585ff"
}))))));
export default SvgBookmarkIconOn;